<template>
  <div class="topic-details">
    <a-select v-model="community" placeholder="请选择发布社区">
      <a-select-option :value="value.id" v-for="value in communityOptions" :key="value.id">{{value.name}}</a-select-option>
    </a-select>
    <a-spin tip="加载中..." :spinning="loading">
      <div class="info">
        <div class="bac">
          <div>
            <p>{{info.category_name}}</p>
            <p># {{info.content}} #</p>
            <p>{{info.content_desc}}</p>
            <a-space>
              <p>{{info.posts_num}}个回帖</p>
              <p>{{info.nickname}}</p>
              <p>{{info.created_at}}</p>
            </a-space>
          </div>
        </div>
        <dy-image :src="value" v-for="value in info.photos" :key="value"></dy-image>
      </div>
      <invitation-details :id="value.id" v-for="value in data" :key="value.id" :community-id="community"></invitation-details>
    </a-spin>
  </div>
</template>

<script>
  import CommunityService from '@/io/community.js';
  import TopicService from '@/io/topic.js';
  import InvitationDetails from '@/views/community/InvitationDetails.vue';

  export default {
    name: 'TopicDetails',
    props: {
      communityIds: {
        type: Array,
        default: null
      },
    },
    data() {
      return {
        loading: false,
        community: [],
        communityOptions: [],
        isShow: false,
        info: {},
        data: [],
        form: {
          note: null,
          avatar: [],
        },
        rules: {
          note: [
            {
              required: true,
              message: '请填写帖子内容'
            }
          ]
        }
      }
    },
    components: {
      InvitationDetails,
    },
    watch: {
      communityIds: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initCommunity();
          }
        },
        immediate: true
      },
      community: {
        handler(newValue, oldValue) {
          if (typeof newValue === 'number') {
            this.initPage(); 
          }
        },
        immediate: true
      }
    },
    methods: {
      handleChange(info) {
        this.form.avatar = info.fileList.map(val => {
          return {
            uid: val.uid,
            name: val.name,
            status: val.status,
            url: val.url || (val.response ? val.response.media : null)
          }
        });
      },
      initCommunity() {
        return CommunityService.listPage().then(res => {
          this.community = this.communityIds[0].community_id;
          this.communityOptions = res.filter(val => this.communityIds.map(m => m.community_id).indexOf(val.id) > -1);
        }).catch(err => {});
      },
      initPage() {
        this.loading = true;
        return TopicService.info(this.community, this.communityIds.filter(val => val.community_id === this.community)[0].topic_id).then(res => {
          this.info = res.meta.topic;
          this.data = res.data;
        }).catch(err => {}).finally(() => {
          this.loading = false;
        });
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          TopicService.addInvitation(
            this.id,
            this.form.note,
            this.form.avatar.map(val => val.url)
          ).then(res => {
            this.$afterFormSubmit('创建成功', () => {
              this.cancel();
            });
          }).catch(err => {});
        });
      },
      cancel() {
        this.isShow = false;
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../../assets/styles/tools.less';
  .topic-details {
    .ant-select {
      margin-bottom: @padding-lg;
      width: 100%;
    }
    .info {
      position: relative;
      color: @white;
      .bac {
        position: absolute;
        background-color: rgba(0, 0, 0, .4);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        p {
          padding: @padding-sm;
          font-size: @font-size-xl;
          &:nth-of-type(2) {
            font-size: @font-size-base + 10px;
            font-weight: bold;
          }
        }
      }
      .dy-image {
        width: 100%;
      }
    }
    .invitation-details {
      margin-top: @padding-lg;
    }
  }
</style>